import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['element'];

  static values = {
    targetSelector: String,
    className: String
  };

  connect() {
    this.intersectionObserver = new IntersectionObserver(this.onIntersection);
    this.intersectionObserver.observe(this.scrollTargetElement);
  }

  scroll() {
    this.scrollTargetElement.scrollIntoView();
  }

  onIntersection = (entries) => {
    const lastEntry = entries.slice(-1)[0];

    if (lastEntry?.isIntersecting) {
      this.element.classList.add(this.classNameValue);
    } else {
      this.element.classList.remove(this.classNameValue);
    }
  }

  disconnect() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }

  get scrollTargetElement() {
    if (this.hasTargetSelectorValue) {
      return document.querySelector(this.targetSelectorValue);
    }

    return this.elementTarget;
  }
}
